import { useMemo } from 'react';
import { RunningInstance } from 'src/common/interfaces/instances';
import TargetMachineSvg from 'src/images/svgs/target-machine.svg';
import AttackBoxSvg from 'src/images/svgs/attackbox.svg';
import { useStartTimeVm } from 'src/common/hooks';
import { ToolTip } from 'src/common/components';
import { StyledTagContent, StyledTag, StyledTagText } from './machine-ip-tag.styles';
type MachineIpTagProps = {
  instance: RunningInstance;
  variant: 'attackbox' | 'target';
  hide: boolean;
};
export const MachineIpTag = ({
  instance,
  variant,
  hide
}: MachineIpTagProps) => {
  const {
    formattedStartTimeLeft,
    hideIpAddress
  } = useStartTimeVm(instance);
  const isAttackBox = variant === 'attackbox';
  const ipDisplayValue = useMemo(() => {
    if (isAttackBox) {
      return instance.remote.privateIP;
    }
    return hideIpAddress ? `Shown in ${formattedStartTimeLeft}` : `${instance.internalIP ?? ''}`;
  }, [formattedStartTimeLeft, hideIpAddress, instance.internalIP, instance.remote.privateIP, isAttackBox]);
  return <StyledTag size="default" $hide={hide} data-sentry-element="StyledTag" data-sentry-component="MachineIpTag" data-sentry-source-file="machine-ip-tag.tsx">
      <StyledTagContent data-sentry-element="StyledTagContent" data-sentry-source-file="machine-ip-tag.tsx">
        <ToolTip toolTipText={isAttackBox ? 'Attacker machine' : 'Target machine'} $fontSize="tiny" side="bottom" data-sentry-element="ToolTip" data-sentry-source-file="machine-ip-tag.tsx">
          {isAttackBox ? <img src={AttackBoxSvg} width={23} height={16} alt="Attacker machine" /> : <img src={TargetMachineSvg} width={16} height={16} alt="Target machine" />}
        </ToolTip>
        IP Address:
        <StyledTagText data-sentry-element="StyledTagText" data-sentry-source-file="machine-ip-tag.tsx">{ipDisplayValue}</StyledTagText>
      </StyledTagContent>
    </StyledTag>;
};